module.exports = __webpack_public_path__ + "static/video-image-8e8aa1e64050e299ca921ca41b06f21c.jpg";